import classNames from "classnames";
import { FunctionComponent, ReactElement, useMemo } from "react";
import styles from "./Circle.module.scss";
import { ICircleProps } from "./types";

export const Circle: FunctionComponent<ICircleProps> = (
  props: ICircleProps
): ReactElement<ICircleProps> => {
  const { backgroundColor, color, total = 0, value = 0 } = props;

  const progress: number = useMemo(() => {
    if (0 === total) {
      return 100;
    } else if (value > total) {
      return 100;
    } else {
      return (100 * value) / total;
    }
  }, [total, value]);

  return (
    <svg
      className={classNames("expenseСhart", styles.containerDefault)}
      //  @ts-expect-error
      percent={progress}
      viewport="0 0 34 34"
    >
      <circle cx="17" cy="17" r="15" stroke={color} />
      <circle cx="17" cy="17" r="15" stroke={color} />
    </svg>
  );
};
